export const ActionAnonymous = {
  REGISTER: 'REGISTER',
  REGISTER_ADMIN: 'REGISTER_ADMIN',
};
